import Vue from 'vue';
import classTender from './class-tender/class-tender.vue';

Vue.component('class-tender', classTender);
